export const countryCurrencyMap = [
  {
    currencyCode: "AED",
    name: "UAE Dirham",
    country: "United Arab Emirates",
    countryCode: "AE",
    rateAgainstUSD: 3.673099,
  },
  {
    currencyCode: "AFN",
    name: "Afghan Afghani",
    country: "Afghanistan",
    countryCode: "AF",
    rateAgainstUSD: 71.071358,
  },
  {
    currencyCode: "ALL",
    name: "Albanian Lek",
    country: "Albania",
    countryCode: "AL",
    rateAgainstUSD: 87.135832,
  },
  {
    currencyCode: "AMD",
    name: "Armenian Dram",
    country: "Armenia",
    countryCode: "AM",
    rateAgainstUSD: 389.460105,
  },
  {
    currencyCode: "ANG",
    name: "Netherlands Antillian Guilder",
    country: "Netherlands Antilles",
    countryCode: "AN",
    rateAgainstUSD: 1.80229,
  },
  {
    currencyCode: "AOA",
    name: "Angolan Kwanza",
    country: "Angola",
    countryCode: "AO",
    rateAgainstUSD: 912.000413,
  },
  {
    currencyCode: "ARS",
    name: "Argentine Peso",
    country: "Argentina",
    countryCode: "AR",
    rateAgainstUSD: 1160.989868,
  },
  {
    currencyCode: "AUD",
    name: "Australian Dollar",
    country: "Australia",
    countryCode: "AU",
    rateAgainstUSD: 1.558822,
  },
  {
    currencyCode: "AWG",
    name: "Aruban Florin",
    country: "Aruba",
    countryCode: "AW",
    rateAgainstUSD: 1.8,
  },
  {
    currencyCode: "AZN",
    name: "Azerbaijani Manat",
    country: "Azerbaijan",
    countryCode: "AZ",
    rateAgainstUSD: 1.69771,
  },
  {
    currencyCode: "BAM",
    name: "Bosnia and Herzegovina Mark",
    country: "Bosnia and Herzegovina",
    countryCode: "BA",
    rateAgainstUSD: 1.723544,
  },
  {
    currencyCode: "BBD",
    name: "Barbados Dollar",
    country: "Barbados",
    countryCode: "BB",
    rateAgainstUSD: 2.019643,
  },
  {
    currencyCode: "BDT",
    name: "Bangladeshi Taka",
    country: "Bangladesh",
    countryCode: "BD",
    rateAgainstUSD: 121.531771,
  },
  {
    currencyCode: "BGN",
    name: "Bulgarian Lev",
    country: "Bulgaria",
    countryCode: "BG",
    rateAgainstUSD: 1.72015,
  },
  {
    currencyCode: "BHD",
    name: "Bahraini Dinar",
    country: "Bahrain",
    countryCode: "BH",
    rateAgainstUSD: 0.376832,
  },
  {
    currencyCode: "BIF",
    name: "Burundian Franc",
    country: "Burundi",
    countryCode: "BI",
    rateAgainstUSD: 2974.836643,
  },
  {
    currencyCode: "BMD",
    name: "Bermudian Dollar",
    country: "Bermuda",
    countryCode: "BM",
    rateAgainstUSD: 1,
  },
  {
    currencyCode: "BND",
    name: "Brunei Dollar",
    country: "Brunei Darussalam",
    countryCode: "BN",
    rateAgainstUSD: 1.314269,
  },
  {
    currencyCode: "BOB",
    name: "Bolivian Boliviano",
    country: "Bolivia",
    countryCode: "BO",
    rateAgainstUSD: 6.926453,
  },
  {
    currencyCode: "BRL",
    name: "Brazilian Real",
    country: "Brazil",
    countryCode: "BR",
    rateAgainstUSD: 5.684699,
  },
  {
    currencyCode: "BSD",
    name: "Bahamian Dollar",
    country: "Bahamas",
    countryCode: "BS",
    rateAgainstUSD: 1.000304,
  },
  {
    currencyCode: "BTN",
    name: "Bhutanese Ngultrum",
    country: "Bhutan",
    countryCode: "BT",
    rateAgainstUSD: 85.011566,
  },
  {
    currencyCode: "BWP",
    name: "Botswana Pula",
    country: "Botswana",
    countryCode: "BW",
    rateAgainstUSD: 13.711969,
  },
  {
    currencyCode: "BYN",
    name: "Belarusian Ruble",
    country: "Belarus",
    countryCode: "BY",
    rateAgainstUSD: 3.273424,
  },
  {
    currencyCode: "BZD",
    name: "Belize Dollar",
    country: "Belize",
    countryCode: "BZ",
    rateAgainstUSD: 2.009218,
  },
  {
    currencyCode: "CAD",
    name: "Canadian Dollar",
    country: "Canada",
    countryCode: "CA",
    rateAgainstUSD: 1.385615,
  },
  {
    currencyCode: "CDF",
    name: "Congolese Franc",
    country: "Democratic Republic of the Congo",
    countryCode: "CD",
    rateAgainstUSD: 2877.000265,
  },
  {
    currencyCode: "CHF",
    name: "Swiss Franc",
    country: "Switzerland",
    countryCode: "CH",
    rateAgainstUSD: 0.824615,
  },
  {
    currencyCode: "CLP",
    name: "Chilean Peso",
    country: "Chile",
    countryCode: "CL",
    rateAgainstUSD: 936.44989,
  },
  {
    currencyCode: "CNY",
    name: "Chinese Renminbi",
    country: "China",
    countryCode: "CN",
    rateAgainstUSD: 7.287699,
  },
  {
    currencyCode: "COP",
    name: "Colombian Peso",
    country: "Colombia",
    countryCode: "CO",
    rateAgainstUSD: 4224.17,
  },
  {
    currencyCode: "CRC",
    name: "Costa Rican Colon",
    country: "Costa Rica",
    countryCode: "CR",
    rateAgainstUSD: 505.747937,
  },
  {
    currencyCode: "CUP",
    name: "Cuban Peso",
    country: "Cuba",
    countryCode: "CU",
    rateAgainstUSD: 26.5,
  },
  {
    currencyCode: "CVE",
    name: "Cape Verdean Escudo",
    country: "Cape Verde",
    countryCode: "CV",
    rateAgainstUSD: 97.169899,
  },
  {
    currencyCode: "CZK",
    name: "Czech Koruna",
    country: "Czech Republic",
    countryCode: "CZ",
    rateAgainstUSD: 21.892031,
  },
  {
    currencyCode: "DJF",
    name: "Djiboutian Franc",
    country: "Djibouti",
    countryCode: "DJ",
    rateAgainstUSD: 178.123417,
  },
  {
    currencyCode: "DKK",
    name: "Danish Krone",
    country: "Denmark",
    countryCode: "DK",
    rateAgainstUSD: 6.55114,
  },
  {
    currencyCode: "DOP",
    name: "Dominican Peso",
    country: "Dominican Republic",
    countryCode: "DO",
    rateAgainstUSD: 58.946645,
  },
  {
    currencyCode: "DZD",
    name: "Algerian Dinar",
    country: "Algeria",
    countryCode: "DZ",
    rateAgainstUSD: 132.360324,
  },
  {
    currencyCode: "EGP",
    name: "Egyptian Pound",
    country: "Egypt",
    countryCode: "EG",
    rateAgainstUSD: 50.828301,
  },
  {
    currencyCode: "ERN",
    name: "Eritrean Nakfa",
    country: "Eritrea",
    countryCode: "ER",
    rateAgainstUSD: 15,
  },
  {
    currencyCode: "ETB",
    name: "Ethiopian Birr",
    country: "Ethiopia",
    countryCode: "ET",
    rateAgainstUSD: 133.890798,
  },
  {
    currencyCode: "EUR",
    name: "Euro",
    country: "European Union",
    countryCode: "eu",
    rateAgainstUSD: 0.87768,
  },
  {
    currencyCode: "FJD",
    name: "Fiji Dollar",
    country: "Fiji",
    countryCode: "FJ",
    rateAgainstUSD: 2.255403,
  },
  {
    currencyCode: "FKP",
    name: "Falkland Islands Pound",
    country: "Falkland Islands",
    countryCode: "FK",
    rateAgainstUSD: 0.751089,
  },
  {
    currencyCode: "FOK",
    name: "Faroese Króna",
    country: "Faroe Islands",
    countryCode: "FO",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "GBP",
    name: "Pound Sterling",
    country: "United Kingdom",
    countryCode: "GB",
    rateAgainstUSD: 0.746275,
  },
  {
    currencyCode: "GEL",
    name: "Georgian Lari",
    country: "Georgia",
    countryCode: "GE",
    rateAgainstUSD: 2.740552,
  },
  {
    currencyCode: "GGP",
    name: "Guernsey Pound",
    country: "Guernsey",
    countryCode: "GG",
    rateAgainstUSD: 0.751089,
  },
  {
    currencyCode: "GHS",
    name: "Ghanaian Cedi",
    country: "Ghana",
    countryCode: "GH",
    rateAgainstUSD: 15.298985,
  },
  {
    currencyCode: "GIP",
    name: "Gibraltar Pound",
    country: "Gibraltar",
    countryCode: "GI",
    rateAgainstUSD: 0.751089,
  },
  {
    currencyCode: "GMD",
    name: "Gambian Dalasi",
    country: "The Gambia",
    countryCode: "GM",
    rateAgainstUSD: 71.435047,
  },
  {
    currencyCode: "GNF",
    name: "Guinean Franc",
    country: "Guinea",
    countryCode: "GN",
    rateAgainstUSD: 8656.000451,
  },
  {
    currencyCode: "GTQ",
    name: "Guatemalan Quetzal",
    country: "Guatemala",
    countryCode: "GT",
    rateAgainstUSD: 7.703866,
  },
  {
    currencyCode: "GYD",
    name: "Guyanese Dollar",
    country: "Guyana",
    countryCode: "GY",
    rateAgainstUSD: 209.26431,
  },
  {
    currencyCode: "HKD",
    name: "Hong Kong Dollar",
    country: "Hong Kong",
    countryCode: "HK",
    rateAgainstUSD: 7.75667,
  },
  {
    currencyCode: "HNL",
    name: "Honduran Lempira",
    country: "Honduras",
    countryCode: "HN",
    rateAgainstUSD: 25.931589,
  },
  {
    currencyCode: "HRK",
    name: "Croatian Kuna",
    country: "Croatia",
    countryCode: "HR",
    rateAgainstUSD: 6.617696,
  },
  {
    currencyCode: "HTG",
    name: "Haitian Gourde",
    country: "Haiti",
    countryCode: "HT",
    rateAgainstUSD: 130.882878,
  },
  {
    currencyCode: "HUF",
    name: "Hungarian Forint",
    country: "Hungary",
    countryCode: "HU",
    rateAgainstUSD: 354.940498,
  },
  {
    currencyCode: "IDR",
    name: "Indonesian Rupiah",
    country: "Indonesia",
    countryCode: "ID",
    rateAgainstUSD: 16799,
  },
  {
    currencyCode: "ILS",
    name: "Israeli New Shekel",
    country: "Israel",
    countryCode: "IL",
    rateAgainstUSD: 3.62347,
  },
  {
    currencyCode: "IMP",
    name: "Manx Pound",
    country: "Isle of Man",
    countryCode: "IM",
    rateAgainstUSD: 0.751089,
  },
  {
    currencyCode: "INR",
    name: "Indian Rupee",
    country: "India",
    countryCode: "IN",
    rateAgainstUSD: 85.1482,
  },
  {
    currencyCode: "IQD",
    name: "Iraqi Dinar",
    country: "Iraq",
    countryCode: "IQ",
    rateAgainstUSD: 1310.326899,
  },
  {
    currencyCode: "IRR",
    name: "Iranian Rial",
    country: "Iran",
    countryCode: "IR",
    rateAgainstUSD: 42099.999945,
  },
  {
    currencyCode: "ISK",
    name: "Icelandic Króna",
    country: "Iceland",
    countryCode: "IS",
    rateAgainstUSD: 128.239869,
  },
  {
    currencyCode: "JEP",
    name: "Jersey Pound",
    country: "Jersey",
    countryCode: "JE",
    rateAgainstUSD: 0.751089,
  },
  {
    currencyCode: "JMD",
    name: "Jamaican Dollar",
    country: "Jamaica",
    countryCode: "JM",
    rateAgainstUSD: 158.455716,
  },
  {
    currencyCode: "JOD",
    name: "Jordanian Dinar",
    country: "Jordan",
    countryCode: "JO",
    rateAgainstUSD: 0.7091,
  },
  {
    currencyCode: "JPY",
    name: "Japanese Yen",
    country: "Japan",
    countryCode: "JP",
    rateAgainstUSD: 142.5965,
  },
  {
    currencyCode: "KES",
    name: "Kenyan Shilling",
    country: "Kenya",
    countryCode: "KE",
    rateAgainstUSD: 129.249862,
  },
  {
    currencyCode: "KGS",
    name: "Kyrgyzstani Som",
    country: "Kyrgyzstan",
    countryCode: "KG",
    rateAgainstUSD: 87.449844,
  },
  {
    currencyCode: "KHR",
    name: "Cambodian Riel",
    country: "Cambodia",
    countryCode: "KH",
    rateAgainstUSD: 4004.300393,
  },
  {
    currencyCode: "KID",
    name: "Kiribati Dollar",
    country: "Kiribati",
    countryCode: "KI",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "KMF",
    name: "Comorian Franc",
    country: "Comoros",
    countryCode: "KM",
    rateAgainstUSD: 432.503383,
  },
  {
    currencyCode: "KRW",
    name: "South Korean Won",
    country: "South Korea",
    countryCode: "KR",
    rateAgainstUSD: 1436.174977,
  },
  {
    currencyCode: "KWD",
    name: "Kuwaiti Dinar",
    country: "Kuwait",
    countryCode: "KW",
    rateAgainstUSD: 0.30658,
  },
  {
    currencyCode: "KYD",
    name: "Cayman Islands Dollar",
    country: "Cayman Islands",
    countryCode: "KY",
    rateAgainstUSD: 0.833645,
  },
  {
    currencyCode: "KZT",
    name: "Kazakhstani Tenge",
    country: "Kazakhstan",
    countryCode: "KZ",
    rateAgainstUSD: 512.978458,
  },
  {
    currencyCode: "LAK",
    name: "Lao Kip",
    country: "Laos",
    countryCode: "la",
    rateAgainstUSD: 21635.125906,
  },
  {
    currencyCode: "LBP",
    name: "Lebanese Pound",
    country: "Lebanon",
    countryCode: "LB",
    rateAgainstUSD: 89622.305645,
  },
  {
    currencyCode: "LKR",
    name: "Sri Lanka Rupee",
    country: "Sri Lanka",
    countryCode: "LK",
    rateAgainstUSD: 299.580086,
  },
  {
    currencyCode: "LRD",
    name: "Liberian Dollar",
    country: "Liberia",
    countryCode: "LR",
    rateAgainstUSD: 200.047586,
  },
  {
    currencyCode: "LSL",
    name: "Lesotho Loti",
    country: "Lesotho",
    countryCode: "LS",
    rateAgainstUSD: 18.675661,
  },
  {
    currencyCode: "LYD",
    name: "Libyan Dinar",
    country: "Libya",
    countryCode: "LY",
    rateAgainstUSD: 5.472499,
  },
  {
    currencyCode: "MAD",
    name: "Moroccan Dirham",
    country: "Morocco",
    countryCode: "MA",
    rateAgainstUSD: 9.274519,
  },
  {
    currencyCode: "MDL",
    name: "Moldovan Leu",
    country: "Moldova",
    countryCode: "MD",
    rateAgainstUSD: 17.134674,
  },
  {
    currencyCode: "MGA",
    name: "Malagasy Ariary",
    country: "Madagascar",
    countryCode: "MG",
    rateAgainstUSD: 4448.478546,
  },
  {
    currencyCode: "MKD",
    name: "Macedonian Denar",
    country: "North Macedonia",
    countryCode: "mk",
    rateAgainstUSD: 54.095046,
  },
  {
    currencyCode: "MMK",
    name: "Burmese Kyat",
    country: "Myanmar",
    countryCode: "MM",
    rateAgainstUSD: 2099.879226,
  },
  {
    currencyCode: "MNT",
    name: "Mongolian Tögrög",
    country: "Mongolia",
    countryCode: "MN",
    rateAgainstUSD: 3570.897913,
  },
  {
    currencyCode: "MOP",
    name: "Macanese Pataca",
    country: "Macau",
    countryCode: "mi",
    rateAgainstUSD: 7.991294,
  },
  {
    currencyCode: "MRU",
    name: "Mauritanian Ouguiya",
    country: "Mauritania",
    countryCode: "MR",
    rateAgainstUSD: 39.589695,
  },
  {
    currencyCode: "MUR",
    name: "Mauritian Rupee",
    country: "Mauritius",
    countryCode: "MU",
    rateAgainstUSD: 45.249712,
  },
  {
    currencyCode: "MVR",
    name: "Maldivian Rufiyaa",
    country: "Maldives",
    countryCode: "MV",
    rateAgainstUSD: 15.41032,
  },
  {
    currencyCode: "MWK",
    name: "Malawian Kwacha",
    country: "Malawi",
    countryCode: "MW",
    rateAgainstUSD: 1734.088255,
  },
  {
    currencyCode: "MXN",
    name: "Mexican Peso",
    country: "Mexico",
    countryCode: "MX",
    rateAgainstUSD: 19.56254,
  },
  {
    currencyCode: "MYR",
    name: "Malaysian Ringgit",
    country: "Malaysia",
    countryCode: "MY",
    rateAgainstUSD: 4.363,
  },
  {
    currencyCode: "MZN",
    name: "Mozambican Metical",
    country: "Mozambique",
    countryCode: "MZ",
    rateAgainstUSD: 64.000004,
  },
  {
    currencyCode: "NAD",
    name: "Namibian Dollar",
    country: "Namibia",
    countryCode: "NA",
    rateAgainstUSD: 18.675661,
  },
  {
    currencyCode: "NGN",
    name: "Nigerian Naira",
    country: "Nigeria",
    countryCode: "NG",
    rateAgainstUSD: 1607.349563,
  },
  {
    currencyCode: "NIO",
    name: "Nicaraguan Córdoba",
    country: "Nicaragua",
    countryCode: "NI",
    rateAgainstUSD: 36.809708,
  },
  {
    currencyCode: "NOK",
    name: "Norwegian Krone",
    country: "Norway",
    countryCode: "NO",
    rateAgainstUSD: 10.359903,
  },
  {
    currencyCode: "NPR",
    name: "Nepalese Rupee",
    country: "Nepal",
    countryCode: "NP",
    rateAgainstUSD: 136.018753,
  },
  {
    currencyCode: "NZD",
    name: "New Zealand Dollar",
    country: "New Zealand",
    countryCode: "NZ",
    rateAgainstUSD: 1.675701,
  },
  {
    currencyCode: "OMR",
    name: "Omani Rial",
    country: "Oman",
    countryCode: "OM",
    rateAgainstUSD: 0.385014,
  },
  {
    currencyCode: "PAB",
    name: "Panamanian Balboa",
    country: "Panama",
    countryCode: "PA",
    rateAgainstUSD: 1.000282,
  },
  {
    currencyCode: "PEN",
    name: "Peruvian Sol",
    country: "Peru",
    countryCode: "PE",
    rateAgainstUSD: 3.666023,
  },
  {
    currencyCode: "PGK",
    name: "Papua New Guinean Kina",
    country: "Papua New Guinea",
    countryCode: "PG",
    rateAgainstUSD: 4.141827,
  },
  {
    currencyCode: "PHP",
    name: "Philippine Peso",
    country: "Philippines",
    countryCode: "PH",
    rateAgainstUSD: 56.389497,
  },
  {
    currencyCode: "PKR",
    name: "Pakistani Rupee",
    country: "Pakistan",
    countryCode: "PK",
    rateAgainstUSD: 281.085792,
  },
  {
    currencyCode: "PLN",
    name: "Polish Złoty",
    country: "Poland",
    countryCode: "PL",
    rateAgainstUSD: 3.744326,
  },
  {
    currencyCode: "PYG",
    name: "Paraguayan Guaraní",
    country: "Paraguay",
    countryCode: "PY",
    rateAgainstUSD: 8009.658473,
  },
  {
    currencyCode: "QAR",
    name: "Qatari Riyal",
    country: "Qatar",
    countryCode: "QA",
    rateAgainstUSD: 3.645953,
  },
  {
    currencyCode: "RON",
    name: "Romanian Leu",
    country: "Romania",
    countryCode: "RO",
    rateAgainstUSD: 4.369499,
  },
  {
    currencyCode: "RSD",
    name: "Serbian Dinar",
    country: "Serbia",
    countryCode: "RS",
    rateAgainstUSD: 103.291019,
  },
  {
    currencyCode: "RUB",
    name: "Russian Ruble",
    country: "Russia",
    countryCode: "RU",
    rateAgainstUSD: 82.647853,
  },
  {
    currencyCode: "RWF",
    name: "Rwandan Franc",
    country: "Rwanda",
    countryCode: "RW",
    rateAgainstUSD: 1411.016184,
  },
  {
    currencyCode: "SAR",
    name: "Saudi Riyal",
    country: "Saudi Arabia",
    countryCode: "SA",
    rateAgainstUSD: 3.751071,
  },
  {
    currencyCode: "SBD",
    name: "Solomon Islands Dollar",
    country: "Solomon Islands",
    countryCode: "SB",
    rateAgainstUSD: 8.354312,
  },
  {
    currencyCode: "SCR",
    name: "Seychellois Rupee",
    country: "Seychelles",
    countryCode: "SC",
    rateAgainstUSD: 14.289793,
  },
  {
    currencyCode: "SDG",
    name: "Sudanese Pound",
    country: "Sudan",
    countryCode: "SD",
    rateAgainstUSD: 600.502667,
  },
  {
    currencyCode: "SEK",
    name: "Swedish Krona",
    country: "Sweden",
    countryCode: "SE",
    rateAgainstUSD: 9.611397,
  },
  {
    currencyCode: "SGD",
    name: "Singapore Dollar",
    country: "Singapore",
    countryCode: "SG",
    rateAgainstUSD: 1.311335,
  },
  {
    currencyCode: "SHP",
    name: "Saint Helena Pound",
    country: "Saint Helena",
    countryCode: "SH",
    rateAgainstUSD: 0.785843,
  },
  {
    currencyCode: "SLL",
    name: "Sierra Leonean Leone",
    country: "Sierra Leone",
    countryCode: "SL",
    rateAgainstUSD: 20969.483762,
  },
  {
    currencyCode: "SOS",
    name: "Somali Shilling",
    country: "Somalia",
    countryCode: "SO",
    rateAgainstUSD: 571.650136,
  },
  {
    currencyCode: "SRD",
    name: "Surinamese Dollar",
    country: "Suriname",
    countryCode: "SR",
    rateAgainstUSD: 36.849708,
  },
  {
    currencyCode: "SSP",
    name: "South Sudanese Pound",
    country: "South Sudan",
    countryCode: "ss",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "STN",
    name: "Sao Tome and Principe Dobra",
    country: "Sao Tome and Principe",
    countryCode: "ST",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "SYP",
    name: "Syrian Pound",
    country: "Syria",
    countryCode: "SY",
    rateAgainstUSD: 13001.925904,
  },
  {
    currencyCode: "SZL",
    name: "Eswatini Lilangeni",
    country: "Eswatini",
    countryCode: "SZ",
    rateAgainstUSD: 18.669945,
  },
  {
    currencyCode: "THB",
    name: "Thai Baht",
    country: "Thailand",
    countryCode: "TH",
    rateAgainstUSD: 33.4105,
  },
  {
    currencyCode: "TJS",
    name: "Tajikistani Somoni",
    country: "Tajikistan",
    countryCode: "TJ",
    rateAgainstUSD: 10.552665,
  },
  {
    currencyCode: "TMT",
    name: "Turkmenistan Manat",
    country: "Turkmenistan",
    countryCode: "TM",
    rateAgainstUSD: 3.51,
  },
  {
    currencyCode: "TND",
    name: "Tunisian Dinar",
    country: "Tunisia",
    countryCode: "TN",
    rateAgainstUSD: 2.983287,
  },
  {
    currencyCode: "TOP",
    name: "Tongan Paʻanga",
    country: "Tonga",
    countryCode: "TO",
    rateAgainstUSD: 2.342102,
  },
  {
    currencyCode: "TRY",
    name: "Turkish Lira",
    country: "Turkey",
    countryCode: "TR",
    rateAgainstUSD: 38.41447,
  },
  {
    currencyCode: "TTD",
    name: "Trinidad and Tobago Dollar",
    country: "Trinidad and Tobago",
    countryCode: "TT",
    rateAgainstUSD: 6.789011,
  },
  {
    currencyCode: "TVD",
    name: "Tuvaluan Dollar",
    country: "Tuvalu",
    countryCode: "TV",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "TWD",
    name: "New Taiwan Dollar",
    country: "Taiwan",
    countryCode: "TW",
    rateAgainstUSD: 32.440403,
  },
  {
    currencyCode: "TZS",
    name: "Tanzanian Shilling",
    country: "Tanzania",
    countryCode: "TZ",
    rateAgainstUSD: 2689.999831,
  },
  {
    currencyCode: "UAH",
    name: "Ukrainian Hryvnia",
    country: "Ukraine",
    countryCode: "UA",
    rateAgainstUSD: 41.699735,
  },
  {
    currencyCode: "UGX",
    name: "Ugandan Shilling",
    country: "Uganda",
    countryCode: "UG",
    rateAgainstUSD: 3668.633317,
  },
  {
    currencyCode: "USD",
    name: "United States Dollar",
    country: "United States",
    countryCode: "US",
    rateAgainstUSD: null,
  },
  {
    currencyCode: "UYU",
    name: "Uruguayan Peso",
    country: "Uruguay",
    countryCode: "UY",
    rateAgainstUSD: 42.114447,
  },
  {
    currencyCode: "UZS",
    name: "Uzbekistani So'm",
    country: "Uzbekistan",
    countryCode: "UZ",
    rateAgainstUSD: 12960.39268,
  },
  {
    currencyCode: "VES",
    name: "Venezuelan Bolíconst Soberano",
    country: "Venezuela",
    countryCode: "VE",
    rateAgainstUSD: 83.31192,
  },
  {
    currencyCode: "VND",
    name: "Vietnamese Đồng",
    country: "Vietnam",
    countryCode: "vn",
    rateAgainstUSD: 26000,
  },
  {
    currencyCode: "VUV",
    name: "Vanuatu Vatu",
    country: "Vanuatu",
    countryCode: "VU",
    rateAgainstUSD: 120.582173,
  },
  {
    currencyCode: "WST",
    name: "Samoan Tālā",
    country: "Samoa",
    countryCode: "WS",
    rateAgainstUSD: 2.763983,
  },
  {
    currencyCode: "XOF",
    name: "West African CFA franc",
    country: "CFA",
    countryCode: "CF",
    rateAgainstUSD: 578.055368,
  },
  {
    currencyCode: "YER",
    name: "Yemeni Rial",
    country: "Yemen",
    countryCode: "YE",
    rateAgainstUSD: 245.050247,
  },
  {
    currencyCode: "ZAR",
    name: "South African Rand",
    country: "South Africa",
    countryCode: "ZA",
    rateAgainstUSD: 18.53095,
  },
  {
    currencyCode: "ZMW",
    name: "Zambian Kwacha",
    country: "Zambia",
    countryCode: "ZM",
    rateAgainstUSD: 27.932286,
  },
  {
    currencyCode: "ZWL",
    name: "Zimbabwean Dollar",
    country: "Zimbabwe",
    countryCode: "ZW",
    rateAgainstUSD: 321.999592,
  },
];
